export default {
  CHANGE_EMAIL: 'CHANGE_EMAIL',
  CLEAR_COUNTERSTRIKE_GLOBAL_OFFENSIVE_SETTINGS: 'CLEAR_COUNTERSTRIKE_GLOBAL_OFFENSIVE_SETTINGS',
  CLEAR_CURRENT_GAMER_PROFILE: 'CLEAR_CURRENT_GAMER_PROFILE',
  CLEAR_CURRENT_GAMER_PURCHASE_PROFILE: 'CLEAR_CURRENT_GAMER_PURCHASE_PROFILE',
  CLEAR_FLICK_POWER_RANKING_COUNT: 'CLEAR_FLICK_POWER_RANKING_COUNT',
  CLEAR_FLICK_POWER_RANKINGS: 'CLEAR_FLICK_POWER_RANKINGS',
  CLEAR_FOLLOW_THROUGH_POWER_RANKING_COUNT: 'CLEAR_FOLLOW_THROUGH_POWER_RANKING_COUNT',
  CLEAR_FOLLOW_THROUGH_POWER_RANKINGS: 'CLEAR_FOLLOW_THROUGH_POWER_RANKINGS',
  CLEAR_FORTNITE_POWER_RANKING_COUNT: 'CLEAR_FORTNITE_POWER_RANKING_COUNT',
  CLEAR_FORTNITE_POWER_RANKINGS: 'CLEAR_FORTNITE_POWER_RANKINGS',
  CLEAR_GAME_INTERFACE: 'CLEAR_GAME_INTERFACE',
  CLEAR_GAME_SOUNDS: 'CLEAR_GAME_SOUNDS',
  CLEAR_GAMERS: 'CLEAR_GAMERS',
  CLEAR_MOBILE_POWER_RANKING_COUNT: 'CLEAR_MOBILE_POWER_RANKING_COUNT',
  CLEAR_MOBILE_POWER_RANKINGS: 'CLEAR_MOBILE_POWER_RANKINGS',
  CLEAR_OTHER_GAMER_PROFILE: 'CLEAR_OTHER_GAMER_PROFILE',
  CLEAR_POWER_RANKING_COUNT: 'CLEAR_POWER_RANKING_COUNT',
  CLEAR_POWER_RANKINGS: 'CLEAR_POWER_RANKINGS',
  CLEAR_SCORES: 'CLEAR_SCORES',
  CLEAR_SPEED_POWER_RANKING_COUNT: 'CLEAR_SPEED_POWER_RANKING_COUNT',
  CLEAR_SPEED_POWER_RANKINGS: 'CLEAR_SPEED_POWER_RANKINGS',
  CLEAR_TRACKING_POWER_RANKING_COUNT: 'CLEAR_TRACKING_POWER_RANKING_COUNT',
  CLEAR_TRACKING_POWER_RANKINGS: 'CLEAR_TRACKING_POWER_RANKINGS',
  CLEAR_WEEKLY_STATISTICS: 'CLEAR_WEEKLY_STATISTICS',
  CREATE_CURRENT_GAMER_PROFILE: 'CREATE_CURRENT_GAMER_PROFILE',
  CREATE_CURRENT_GAMER_PURCHASE_PROFILE: 'CREATE_CURRENT_GAMER_PURCHASE_PROFILE',
  CREATE_WEEKLY_STATISTICS: 'CREATE_WEEKLY_STATISTICS',
  DELETE_CURRENT_GAMER_PROFILE: 'DELETE_CURRENT_GAMER_PROFILE',
  DELETE_CURRENT_GAMER_PURCHASE_PROFILE: 'DELETE_CURRENT_GAMER_PURCHASE_PROFILE',
  DELETE_FLICK_POWER_RANKING: 'DELETE_FLICK_POWER_RANKING',
  DELETE_FOLLOW_THROUGH_POWER_RANKING: 'DELETE_FOLLOW_THROUGH_POWER_RANKING',
  DELETE_FORTNITE_POWER_RANKING: 'DELETE_FORTNITE_POWER_RANKING',
  DELETE_GAMER: 'DELETE_GAMER',
  DELETE_MOBILE_POWER_RANKING: 'DELETE_MOBILE_POWER_RANKING',
  DELETE_POWER_RANKING: 'DELETE_POWER_RANKING',
  DELETE_SCORES: 'DELETE_SCORES',
  DELETE_SPEED_POWER_RANKING: 'DELETE_SPEED_POWER_RANKING',
  DELETE_TRACKING_POWER_RANKING: 'DELETE_TRACKING_POWER_RANKING',
  DISPLAY_ERROR: 'DISPLAY_ERROR',
  HIDE_DIALOG: 'HIDE_DIALOG',
  HIDE_SNACKBAR: 'HIDE_SNACKBAR',
  INDEX_CACHE: 'INDEX_CACHE',
  LOCATION_CHANGE: '@@router/LOCATION_CHANGE',
  SET_ARTICLES: 'SET_ARTICLES',
  SET_COUNTER_STRIKE_GLOBAL_OFFENSIVE_PACK: 'SET_COUNTER_STRIKE_GLOBAL_OFFENSIVE_PACK',
  SET_COUNTER_STRIKE_GLOBAL_OFFENSIVE_WEAPON: 'SET_COUNTER_STRIKE_GLOBAL_OFFENSIVE_WEAPON',
  SET_CURRENT_GAMER: 'SET_CURRENT_GAMER',
  SET_CURRENT_GAMER_PROFILE: 'SET_CURRENT_GAMER_PROFILE',
  SET_CURRENT_GAMER_PURCHASE_PROFILE: 'SET_CURRENT_GAMER_PURCHASE_PROFILE',
  SET_DONATION_AMOUNT: 'SET_DONATION_AMOUNT',
  SET_FLICK_POWER_RANKING_COUNT: 'SET_FLICK_POWER_RANKING_COUNT',
  SET_FLICK_POWER_RANKINGS: 'SET_FLICK_POWER_RANKINGS',
  SET_FOLLOW_THROUGH_POWER_RANKING_COUNT: 'SET_FOLLOW_THROUGH_POWER_RANKING_COUNT',
  SET_FOLLOW_THROUGH_POWER_RANKINGS: 'SET_FOLLOW_THROUGH_POWER_RANKINGS',
  SET_FORTNITE_PACK: 'SET_FORTNITE_PACK',
  SET_FORTNITE_POWER_RANKING_COUNT: 'SET_FORTNITE_POWER_RANKING_COUNT',
  SET_FORTNITE_POWER_RANKINGS: 'SET_FORTNITE_POWER_RANKINGS',
  SET_GAME_SOUNDS: 'SET_GAME_SOUNDS',
  SET_GAMER: 'SET_GAMER',
  SET_GAMERS: 'SET_GAMERS',
  SET_MOBILE_POWER_RANKING_COUNT: 'SET_MOBILE_POWER_RANKING_COUNT',
  SET_MOBILE_POWER_RANKINGS: 'SET_MOBILE_POWER_RANKINGS',
  SET_OVERALL_STATISTICS: 'SET_OVERALL_STATISTICS',
  SET_OTHER_GAMER: 'SET_OTHER_GAMER',
  SET_OTHER_GAMER_PROFILE: 'SET_OTHER_GAMER_PROFILE',
  SET_POWER_RANKING_COUNT: 'SET_POWER_RANKING_COUNT',
  SET_POWER_RANKINGS: 'SET_POWER_RANKINGS',
  SET_SCORES: 'SET_SCORES',
  SET_SHOWDOWN_PACK: 'SET_SHOWDOWN_PACK',
  SET_SPEED_POWER_RANKING_COUNT: 'SET_SPEED_POWER_RANKING_COUNT',
  SET_SPEED_POWER_RANKINGS: 'SET_SPEED_POWER_RANKINGS',
  SET_SOUND_PACK: 'SET_SOUND_PACK',
  SET_TRACKING_POWER_RANKING_COUNT: 'SET_TRACKING_POWER_RANKING_COUNT',
  SET_TRACKING_POWER_RANKINGS: 'SET_TRACKING_POWER_RANKINGS',
  SET_WEEKLY_STATISTICS: 'SET_WEEKLY_STATISTICS',
  SET_WHITELIST: 'SET_WHITELIST',
  SHOW_SNACKBAR: 'SHOW_SNACKBAR',
  SHOW_DIALOG: 'SHOW_DIALOG',
  SIGN_IN: 'SIGN_IN',
  SIGN_OUT: 'SIGN_OUT',
  SIGNING_IN: 'SIGNING_IN',
  UPDATE_CURRENT_GAMER_PROFILE: 'UPDATE_CURRENT_GAMER_PROFILE',
  UPDATE_CURRENT_GAMER_PURCHASE_PROFILE: 'UPDATE_CURRENT_GAMER_PURCHASE_PROFILE',
  UPDATE_GAME_INTERFACE: 'UPDATE_GAME_INTERFACE',
  UPDATE_GAMER: 'UPDATE_GAMER',
  UPDATE_SCORE: 'UPDATE_SCORE',
  UPDATE_USER_INTERFACE: 'UPDATE_USER_INTERFACE',
  UPDATE_ROUTE_PARAMS: 'UPDATE_ROUTE_PARAMS',
}



// WEBPACK FOOTER //
// ./src/app/const/actionTypes.js